import React from 'react';
import { motion } from 'framer-motion';

const colors = {
  secondary: '#9f7aea',
  accent: '#f687b3',
  text: '#e2e8f0',
};

const Experience = ({ role, company, period, responsibilities = [] }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="mb-4"
    >
      <h3 className="text-lg font-semibold" style={{ color: colors.secondary }}>{role}</h3>
      <p style={{ color: colors.text }}>{company}</p>
      <p className="text-sm" style={{ color: colors.accent }}>{period}</p>
      <ul className="list-disc list-inside">
        {responsibilities.map((item, index) => (
          <li key={index} style={{ color: colors.text }}>
            {item}
          </li>
        ))}
      </ul>
    </motion.div>
  );
};

export default Experience;
